import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors as userSelectors } from 'builder/modules/user'

export const useRemainingAiWorkExperienceAttempts = () => {
  const isPremiumUser = useTypedSelector(userSelectors.premiumAccess)
  const aiWorkExperienceFreeAttempts = useTypedSelector(userSelectors.aiWorkExperienceFreeAttempts)

  if (isPremiumUser) {
    return Infinity
  }

  return aiWorkExperienceFreeAttempts || 0
}
